import React from 'react'
import PageBody from 'Common/Custom/PageBody'
import AddItemBtn from 'Common/Custom/AddItemBtn'
import { HeadingOne } from 'Common/Custom/HeadingOne'

import RoomListTable from './Components/RoomListTable'

const RoomList = () => {
    return (
        <PageBody
            card={true}
            headerchildren={
                <>
                    <HeadingOne>Room List</HeadingOne>
                    <div className='d-flex gap-2 flex-wrap mt-sm-0 mt-2'>
                        <AddItemBtn url="add-room" title="Add Room" />
                        <AddItemBtn url="assign-room" title="Assign Room" />
                        {/* <AddItemBtn url="assign-room-offer" title="Assign Room Offer" /> */}
                        <AddItemBtn url="assign-room-facilities" title="Assign Room Facilities" />
                    </div>
                </>
            }>

            {/* Table section */}
            <div className="col-12">
                <RoomListTable />
            </div>
        </PageBody>
    )
}

export default RoomList